import { render } from "./index.vue?vue&type=template&id=d79ec2be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d79ec2be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d79ec2be"],['__file',"src/components/BaseUi/FormCard/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d79ec2be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d79ec2be', __exports__)) {
    api.reload('d79ec2be', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=d79ec2be&scoped=true", () => {
    api.rerender('d79ec2be', render)
  })

}


export default __exports__